import { forwardRef } from "react";

import { MetadataIcon } from "@/types";
import { IconWithBackground } from "../Icon";
import {
  defaultGroupIcon,
  defaultOrganizationIcon,
  defaultProjectIcon,
  defaultResourceIcon,
  defaultUserIcon,
} from "./resourceIcons";

interface ResourceIconProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  type: string;
  icon?: MetadataIcon | null;
}

export const ResourceIcon = forwardRef<HTMLDivElement, ResourceIconProps>(
  ({ type, icon, size = 30, className, ...props }, ref) => {
    const defaultIcon = (() => {
      switch (type) {
        case "organization":
          return defaultOrganizationIcon;
        case "group":
          return defaultGroupIcon;
        case "user":
        case "organization_user":
          return defaultUserIcon;
        case "folder":
        case "project":
          return defaultProjectIcon;
        default:
          return defaultResourceIcon;
      }
    })();

    return (
      <div ref={ref} className={className} {...props}>
        <IconWithBackground icon={icon || defaultIcon} size={size} />
      </div>
    );
  },
);

ResourceIcon.displayName = "ResourceIcon";
